export const SEARCH_TYPE = 'favourites';
